import {Injectable, inject} from '@angular/core';
import { HttpService } from './http.service';
import {Observable, catchError, map, tap, throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {LoginResponse} from '../models/user.model';
import {Router} from '@angular/router';
import { AESKey, ErufileConfig } from '../models/erufiles.model';
import { Storages } from '../models/erufiles.model';

@Injectable({
  providedIn: 'root'
})
export class ErufileService {
    private router = inject(Router);
    constructor (private httpService: HttpService) { }

    fetchConfig(url: string, project_name: string): Observable<{ project: ErufileConfig }> {
        return this.httpService.get<any>(
            `${url}/store/${project_name}/config`
        ).pipe(
            map(response => {
                if (response && response.project) {
                    return { project: response.project };
                } else {
                    return { project: {} };
                }
            }),
            catchError((error: HttpErrorResponse) => {
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Projects not found'));
            })
        );
    }


    saveStorage(url: string,project_name:string, storageData:Storages ): Observable<any> {
        return this.httpService.post<any>(
            `${url}/store/${project_name}/storage/save/${storageData.storage_name}/${storageData.storage_type}`,
            storageData // Provide an empty body or the required payload
        ).pipe(
            tap(response => console.log('Storage saved successfully:', response)),
            catchError((error: HttpErrorResponse) => {
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to save storage'));
            })
        );
    }

    saveKey(url:string,project_name:string,key_name:string,
        keyform:AESKey):Observable<any>{
            return this.httpService.post<any>(
                `${url}/store/${project_name}/aeskey/generate/${key_name}`,keyform
            ).pipe(
                catchError((error:HttpErrorResponse)=>{
                    return throwError(()=>new Error(error.error?.error||'Failed to save variables'))
                })
            );
        }
        
    deleteStorage(url: string,project_name:string, storageData:Storages):Observable<any>{
        return this.httpService.delete<any>(
            `${url}/store/${project_name}/storage/remove/${storageData.storage_name}`,
        ).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to delete storage'));
            })
        );
    }

    // There is no update route; save is an upsert keyed by storage name
    updateStorage(url: string, project_name: string, storageData: Storages): Observable<any> {
        return this.saveStorage(url, project_name, storageData);
    }

    generateRsaKeyPair(url: string, project_name: string, key_pair_name: string,
        body: { bits: string; overwrite: string }): Observable<any> {
        return this.httpService.post<any>(
            `${url}/store/${project_name}/rsakeypair/generate/${key_pair_name}`, body
        ).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to generate RSA key pair'));
            })
        );
    }

    loginWithUserPassword(url: string, username: string, password: string): Observable<LoginResponse> {
        return this.httpService.post<LoginResponse>(
            url,
            { username, password }
        ).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Login failed'));
            })
        );
    }
}